<router-outlet></router-outlet>
<button *ngIf="supportButton.visible && supportButton.initialized" mat-button class="support-button primary cta" (click)="supportButton.toggle()">
	<mat-icon>support_agent</mat-icon>
	Support
</button>